<template>
    <div class="map">
        <button
            @click="showMap = !showMap"
            class="button button--green map__button"
            type="button"
        >
            <v-icon name="locate"/>
            <span v-text="showMap ? 'Ver mapa' : 'Ocultar mapa'"></span>
        </button>
        <div
            id="map"
            v-show="!showMap"
        ></div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl'
export default {
    props: {
        lon: {
            type: String,
            required: true
        },
        lat: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showMap: false,
            // token: 'pk.eyJ1IjoiZ2FjaGlubmkiLCJhIjoiY2pxYmV1c2YwMHQ0dDQzbW5yemxtYmhkYSJ9.evJJmAQAo9wGcXinPuwP9A'
            token: 'pk.eyJ1IjoibWFydGlsbGVyb3N1bmlkb3MiLCJhIjoiY2toNm0ydWZwMDMxbTJzcGZmZmQydms4OCJ9.rqdk_eoGtrBBOGsw5AmG4g'
        }
    },
    methods: {
        loadMap() {
            const mq = window.matchMedia('(max-width: 768px)')
            mapboxgl.accessToken = this.token

            let map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [this.lon, this.lat],
                zoom: 14
            })

            map.on('load', () => {
                map.loadImage('/img/marker.png', (error, image) => {
                    if (error) throw error
                    map.addImage('cat', image)
                    map.addLayer({
                        id: 'points',
                        type: 'symbol',
                        source: {
                            type: 'geojson',
                            data: {
                                type: 'FeatureCollection',
                                features: [
                                    {
                                        type: 'Feature',
                                        geometry: {
                                            type: 'Point',
                                            coordinates: [this.lon, this.lat]
                                        }
                                    }
                                ]
                            }
                        },
                        layout: {
                            'icon-image': 'cat',
                            'icon-size': 0.08
                        }
                    })
                })
                if (mq.matches) {
                    map.scrollZoom.disable()
                }
            })
        }
    },
    created() {
        this.$nextTick(() => {
            this.loadMap()
        })
    }
}
</script>

<style lang="scss">
@import url('https://api.mapbox.com/mapbox-gl-js/v0.52.0/mapbox-gl.css');
#map {
    height: 400px;
    margin-top: 1rem;
    @media (max-width: 768px) {
        height: 300px;
    }
}

.map {
    padding: 1rem;
    &__button {
        svg {
            margin-right: 0.5rem;
            height: 24px;
            width: 24px;
            fill: #ffffff;
        }
        span {
            color: #ffffff;
        }
    }
    @media (max-width: 768px) {
        &__button {
        }
    }
}
</style>
